import './DaemonTag.css';

// The bestowed two-word identity: [Material] [Animal]
// In-conversation: shown as a ghost (opacity 0.12)
// Post-shatter: shown at full opacity, large
export default function DaemonTag({ material, animal, visibility = 'hidden' }) {
  // visibility: 'hidden' | 'ghost' | 'born' | 'display'
  if (!material && !animal) return null;

  return (
    <div className={`daemon-tag daemon-tag-${visibility}`} aria-label={`${material} ${animal}`}>
      <div className="dt-rule" />
      <span className="dt-material">{(material || '').toUpperCase()}</span>
      <span className="dt-animal">{(animal || '').toUpperCase()}</span>
      <div className="dt-rule" />
    </div>
  );
}
